import { Badge, Flex, FormControl, FormHelperText, FormLabel, Text } from '@chakra-ui/react'

import { CUSTOM_FORM_KIND_NAME } from 'components/tools/CustomForm/constants'
import { useCustomFormViewer } from '../../../contexts/CustomFormViewerManager/Provider'
import CustomFormViewerQuestion from '../../../components/CustomFormViewerQuestion'
import CustomFormViewerQuestionSelection from '../../../components/CustomFormViewerQuestion/components/CustomFormViewerQuestionSelection'

export default function SolicitacaoDeFeriasAGSUS_Rejeicao() {
  const { questions, formMethods } = useCustomFormViewer()
  const { watch } = formMethods

  const titleForQuestion = Object.fromEntries(questions.map((q) => [q.title, q.slug]))

  const justificativaRejeicao = watch ? watch(`form_answers.${titleForQuestion['JUSTIFICATIVA REJEIÇÃO']}`) : undefined

  if (!questions) return null

  return (
    <Flex bg="transparent" flexDir="column" gap={2} borderTop="1px solid" borderColor="primary">
      {questions.map((question, index) => {
        //CTPS
        if (question.title == 'Justificativa') {
          if (justificativaRejeicao == 'Outro') {
            return (
              <Flex key={index} bg="bgContent" rounded="md" p={2}>
                <FormControl gap={2}>
                  <Flex
                    alignItems="center"
                    justifyContent="space-between"
                    borderBottom="1px solid"
                    borderColor="borderColor"
                    pb={2}
                    mb={2}
                  >
                    <Badge>{CUSTOM_FORM_KIND_NAME[question?.kind || 'Desconhecido']}</Badge>
                    <Text variant="secondary">
                      <Text as="span">{Number(index) + 1}</Text>
                      <Text as="span">/{questions?.length}</Text>
                    </Text>
                  </Flex>
                  <FormLabel mb={question?.description ? 0 : 2}>{question?.title || 'Questão sem título'}</FormLabel>
                  {question?.description && <FormHelperText>{question?.description}</FormHelperText>}
                  <CustomFormViewerQuestionSelection question={question} disabled={false} />
                </FormControl>
              </Flex>
            )
          } else {
            return <></>
          }
        }

        return (
          <CustomFormViewerQuestion
            key={index}
            index={index}
            questionsLength={questions.length}
            question={question}
            disabled={false}
          />
        )
      })}
    </Flex>
  )
}
